import { render } from "./TableFooter.vue?vue&type=template&id=5135bb22&ts=true"
import script from "./TableFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableFooter.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/table/TableFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5135bb22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5135bb22', __exports__)) {
    api.reload('5135bb22', __exports__)
  }
  
  module.hot.accept("./TableFooter.vue?vue&type=template&id=5135bb22&ts=true", () => {
    api.rerender('5135bb22', render)
  })

}


export default __exports__